/**
 * iter v33 r36 · Componente invisibile che si iscrive al tracker globale
 * dei batch enhance e produce toast di NOTIFICA solo quando un job
 * TERMINA (completed/failed/cancelled/credits_exhausted). Il progresso
 * intermedio e' mostrato dalla `<BatchTrayPill />`, non da toast.
 *
 * Cosi' l'agente non ha piu' il pop-up in alto che copre il menu: vede
 * la pill discreta in basso durante il lavoro, e riceve UN solo toast
 * finale al termine.
 */
import { useEffect } from "react";
import { toast } from "sonner";
import { useBatchEnhanceTracker } from "@/context/BatchEnhanceTracker";

export default function BatchCompletionToaster() {
  const { registerOnComplete } = useBatchEnhanceTracker();

  useEffect(() => {
    registerOnComplete(({ status, done, total, errors, propertyTitle }) => {
      const label = propertyTitle ? ` · ${propertyTitle}` : "";
      const tid = `batch-complete-${Date.now()}`;
      if (status === "cancelled") {
        toast.info(`Annullato · ${done}/${total} già fatte${label}`, { id: tid });
      } else if (status === "credits_exhausted") {
        toast.info(`${done}/${total} migliorate · crediti finiti${label}`, { id: tid });
      } else if (status === "failed") {
        toast.error(`Migliora tutte non riuscito${label}`, { id: tid });
      } else if (status === "completed") {
        if (errors > 0 && done > 0) {
          toast.success(
            `${done}/${total} foto migliorate · ${errors} da riprovare${label}`,
            { id: tid, duration: 8000 },
          );
        } else if (done === 0) {
          toast.error(
            `Nessuna foto migliorata · riprova a mano${label}`,
            { id: tid, duration: 8000 },
          );
        } else {
          toast.success(
            `${done}/${total} foto migliorate${label}`,
            { id: tid, duration: 6000 },
          );
        }
      }
    });
  }, [registerOnComplete]);

  return null;
}
